"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFragment = void 0;
function getFragment(fragmentName) {
    var fragment = window[fragmentName];
    if (!fragment) {
        throw new Error("Fragment ".concat(fragmentName, " was not initialized"));
    }
    return fragment;
}
exports.getFragment = getFragment;
